import { currentTimeMillis, generateHex, Module } from '@nu-art/ts-common';
import { Const_LaunchSmart } from '@app/fhir-shared';
import { ModuleFE_EMInterface } from '../../_entity/runtime/em-interface/index.js';
export class ModuleFE_SmartOnFHIR_Class extends Module {
    constructor() {
        super();
    }
    launchSmart = async (request) => {
        const ehrInstanceId = request['ehr-id'];
        delete request['ehr-id'];
        const SoFQueryParams = request;
        SoFQueryParams['ehrInstanceId'] = ehrInstanceId;
        SoFQueryParams['sessionId'] = generateHex(32);
        return ModuleFE_EMInterface.vv1.smartOnFHIR.smartOnFhir(SoFQueryParams).executeSync();
    };
    launchDeploy = async (request) => {
        request['sessionId'] = generateHex(32);
        return ModuleFE_EMInterface.vv1.smartOnFHIR.temp_deployIntegration(request).executeSync();
    };
    getSmartOnFhirLaunchUrl = async (patientIdToLaunch, environmentId, facilityId, userType) => {
        const launchUrlParams = {
            patientId: patientIdToLaunch,
            environmentId,
            facilityId,
            launchUrl: `${window.location.origin}/${Const_LaunchSmart}`,
            userType
        };
        const smartOnFhirLaunchData = await ModuleFE_EMInterface.vv1.smartOnFHIR.getSandboxLaunchUrl(launchUrlParams).executeSync();
        this.logInfo(smartOnFhirLaunchData);
        this.logInfo(smartOnFhirLaunchData.data.url);
        return `${smartOnFhirLaunchData.data.url}&updated=${currentTimeMillis()}`;
    };
}
export const ModuleFE_SmartOnFHIR = new ModuleFE_SmartOnFHIR_Class();
//# sourceMappingURL=ModuleFE_SmartOnFHIR.js.map